var map = {
	"./alarm-fill.svg": "18f0",
	"./alarm.svg": "92a6",
	"./align-bottom.svg": "3bad",
	"./align-center.svg": "c209",
	"./align-end.svg": "d0e0",
	"./align-middle.svg": "f007",
	"./align-start.svg": "3b49",
	"./align-top.svg": "8961",
	"./alt.svg": "250e",
	"./app-indicator.svg": "1141",
	"./app.svg": "435a",
	"./archive-fill.svg": "ba5b",
	"./archive.svg": "13de",
	"./arrow-90deg-down.svg": "da58",
	"./arrow-90deg-left.svg": "4877",
	"./arrow-90deg-right.svg": "4da6",
	"./arrow-90deg-up.svg": "7438",
	"./arrow-bar-down.svg": "2b96",
	"./arrow-bar-left.svg": "621c",
	"./arrow-bar-right.svg": "980f",
	"./arrow-bar-up.svg": "d035",
	"./arrow-clockwise.svg": "125b",
	"./arrow-counterclockwise.svg": "cece",
	"./arrow-down-circle-fill.svg": "cdcf",
	"./arrow-down-circle.svg": "c8ba2",
	"./arrow-down-left-circle-fill.svg": "5c24",
	"./arrow-down-left-circle.svg": "6163",
	"./arrow-down-left-square-fill.svg": "0c1f",
	"./arrow-down-left-square.svg": "0408",
	"./arrow-down-left.svg": "e556",
	"./arrow-down-right-circle-fill.svg": "191b",
	"./arrow-down-right-circle.svg": "6398",
	"./arrow-down-right-square-fill.svg": "8a8d",
	"./arrow-down-right-square.svg": "638f",
	"./arrow-down-right.svg": "d718",
	"./arrow-down-short.svg": "d978",
	"./arrow-down-square-fill.svg": "194d",
	"./arrow-down-square.svg": "bab2",
	"./arrow-down-up.svg": "7334",
	"./arrow-down.svg": "cdea",
	"./arrow-left-circle-fill.svg": "f4c7",
	"./arrow-left-circle.svg": "6e83",
	"./arrow-left-right.svg": "9bf7",
	"./arrow-left-short.svg": "1dd5",
	"./arrow-left-square-fill.svg": "1741",
	"./arrow-left-square.svg": "be0d",
	"./arrow-left.svg": "5aa2",
	"./arrow-repeat.svg": "489f",
	"./arrow-return-left.svg": "fda2",
	"./arrow-return-right.svg": "9ea1",
	"./arrow-right-circle-fill.svg": "f36f",
	"./arrow-right-circle.svg": "603d",
	"./arrow-right-short.svg": "2f49",
	"./arrow-right-square-fill.svg": "641e",
	"./arrow-right-square.svg": "c8b8",
	"./arrow-right.svg": "3cd9",
	"./arrow-up-circle-fill.svg": "14de",
	"./arrow-up-circle.svg": "41ec",
	"./arrow-up-left-circle-fill.svg": "5ae7",
	"./arrow-up-left-circle.svg": "4a3a",
	"./arrow-up-left-square-fill.svg": "2e6d",
	"./arrow-up-left-square.svg": "6b25",
	"./arrow-up-left.svg": "4251",
	"./arrow-up-right-circle-fill.svg": "d1f7",
	"./arrow-up-right-circle.svg": "5358",
	"./arrow-up-right-square-fill.svg": "5641",
	"./arrow-up-right-square.svg": "146e",
	"./arrow-up-right.svg": "958c",
	"./arrow-up-short.svg": "dc08",
	"./arrow-up-square-fill.svg": "00f7",
	"./arrow-up-square.svg": "fb42",
	"./arrow-up.svg": "d8b5",
	"./arrows-angle-contract.svg": "6f24",
	"./arrows-angle-expand.svg": "2fdd",
	"./arrows-collapse.svg": "35758",
	"./arrows-expand.svg": "cb48",
	"./arrows-fullscreen.svg": "0127",
	"./arrows-move.svg": "99a6",
	"./aspect-ratio-fill.svg": "6a12",
	"./aspect-ratio.svg": "5df5",
	"./asterisk.svg": "0dd9",
	"./at.svg": "499c",
	"./award-fill.svg": "2f53",
	"./award.svg": "5043",
	"./back.svg": "8d66",
	"./backspace-fill.svg": "27b0",
	"./backspace-reverse-fill.svg": "3bca",
	"./backspace-reverse.svg": "9e15",
	"./backspace.svg": "6d50",
	"./badge-3d-fill.svg": "477e",
	"./badge-3d.svg": "6734",
	"./badge-4k-fill.svg": "c160",
	"./badge-4k.svg": "ed10",
	"./badge-8k-fill.svg": "fce1",
	"./badge-8k.svg": "74c3",
	"./badge-ad-fill.svg": "2678",
	"./badge-ad.svg": "102e",
	"./badge-ar-fill.svg": "0a22",
	"./badge-ar.svg": "3219",
	"./badge-cc-fill.svg": "d9dc",
	"./badge-cc.svg": "0001",
	"./badge-hd-fill.svg": "3ece",
	"./badge-hd.svg": "84f8",
	"./badge-tm-fill.svg": "82fb",
	"./badge-tm.svg": "5e84",
	"./badge-vo-fill.svg": "db50",
	"./badge-vo.svg": "78de",
	"./badge-vr-fill.svg": "2f6c",
	"./badge-vr.svg": "211a",
	"./badge-wc-fill.svg": "cb66",
	"./badge-wc.svg": "5f4b",
	"./bag-check-fill.svg": "1b49",
	"./bag-check.svg": "0af4",
	"./bag-dash-fill.svg": "f69b",
	"./bag-dash.svg": "9be0",
	"./bag-fill.svg": "aaee",
	"./bag-plus-fill.svg": "40e7",
	"./bag-plus.svg": "c192",
	"./bag-x-fill.svg": "edb3",
	"./bag-x.svg": "e7ef",
	"./bag.svg": "aa25",
	"./bar-chart-fill.svg": "5896",
	"./bar-chart-line-fill.svg": "34a5",
	"./bar-chart-line.svg": "ad16",
	"./bar-chart-steps.svg": "92fe",
	"./bar-chart.svg": "55ab",
	"./basket-fill.svg": "70cd",
	"./basket.svg": "8b6f",
	"./basket2-fill.svg": "b70e",
	"./basket2.svg": "741f",
	"./basket3-fill.svg": "0d26",
	"./basket3.svg": "8bb0",
	"./battery-charging.svg": "155f",
	"./battery-full.svg": "68bc",
	"./battery-half.svg": "61a3",
	"./battery.svg": "6713",
	"./bell-fill.svg": "9e24",
	"./bell.svg": "4003",
	"./bezier.svg": "b7fe",
	"./bezier2.svg": "b906",
	"./bicycle.svg": "0259",
	"./binoculars-fill.svg": "12e9",
	"./binoculars.svg": "0527",
	"./blockquote-left.svg": "7eb5",
	"./blockquote-right.svg": "f8fd",
	"./book-fill.svg": "eeaf",
	"./book-half.svg": "3915",
	"./book.svg": "d113",
	"./bookmark-check-fill.svg": "7f9a",
	"./bookmark-check.svg": "0e84",
	"./bookmark-dash-fill.svg": "3912",
	"./bookmark-dash.svg": "c416",
	"./bookmark-fill.svg": "f63b",
	"./bookmark-heart-fill.svg": "1ccf",
	"./bookmark-heart.svg": "98a5",
	"./bookmark-plus-fill.svg": "b4d1",
	"./bookmark-plus.svg": "f62d",
	"./bookmark-star-fill.svg": "175b",
	"./bookmark-star.svg": "b1a7",
	"./bookmark-x-fill.svg": "ed46",
	"./bookmark-x.svg": "e1c4",
	"./bookmark.svg": "7c47",
	"./bookmarks-fill.svg": "028d",
	"./bookmarks.svg": "d4ba",
	"./bookshelf.svg": "5b12",
	"./bootstrap-fill.svg": "1b6e",
	"./bootstrap-reboot.svg": "7252",
	"./bootstrap.svg": "ca91",
	"./border-all.svg": "3f66",
	"./border-bottom.svg": "0fe2",
	"./border-center.svg": "c03d",
	"./border-inner.svg": "7980",
	"./border-left.svg": "7d6f",
	"./border-middle.svg": "d60a",
	"./border-outer.svg": "9ee6",
	"./border-right.svg": "314c",
	"./border-style.svg": "9c66",
	"./border-top.svg": "8dcb",
	"./border-width.svg": "2c67",
	"./border.svg": "86a7",
	"./bounding-box-circles.svg": "64a5",
	"./bounding-box.svg": "99d8",
	"./box-arrow-down-left.svg": "6ca0",
	"./box-arrow-down-right.svg": "99f2",
	"./box-arrow-down.svg": "1224",
	"./box-arrow-in-down-left.svg": "f5e0",
	"./box-arrow-in-down-right.svg": "2cd9",
	"./box-arrow-in-down.svg": "3ee4",
	"./box-arrow-in-left.svg": "80ee",
	"./box-arrow-in-right.svg": "fc67",
	"./box-arrow-in-up-left.svg": "a752",
	"./box-arrow-in-up-right.svg": "d13e",
	"./box-arrow-in-up.svg": "a32a",
	"./box-arrow-left.svg": "82b7",
	"./box-arrow-right.svg": "ea6c",
	"./box-arrow-up-left.svg": "47b3",
	"./box-arrow-up-right.svg": "9807",
	"./box-arrow-up.svg": "47a3",
	"./box-seam.svg": "8f4a",
	"./box.svg": "e644",
	"./braces.svg": "6310",
	"./bricks.svg": "50ea",
	"./briefcase-fill.svg": "3081",
	"./briefcase.svg": "5edf",
	"./brightness-alt-high-fill.svg": "ee14",
	"./brightness-alt-high.svg": "5f21",
	"./brightness-alt-low-fill.svg": "8f59",
	"./brightness-alt-low.svg": "58c5",
	"./brightness-high-fill.svg": "f0b2",
	"./brightness-high.svg": "8620",
	"./brightness-low-fill.svg": "0026",
	"./brightness-low.svg": "3576",
	"./broadcast-pin.svg": "231f",
	"./broadcast.svg": "02b4",
	"./brush-fill.svg": "2ff7",
	"./brush.svg": "35b7",
	"./bucket-fill.svg": "3ef2",
	"./bucket.svg": "8208",
	"./bug-fill.svg": "6797",
	"./bug.svg": "7ce5",
	"./building.svg": "6ee5",
	"./bullseye.svg": "e906",
	"./calculator-fill.svg": "0949",
	"./calculator.svg": "c43f",
	"./calendar-check-fill.svg": "6727",
	"./calendar-check.svg": "a546",
	"./calendar-date-fill.svg": "0ffb",
	"./calendar-date.svg": "34ea",
	"./calendar-day-fill.svg": "bc95",
	"./calendar-day.svg": "d29a",
	"./calendar-event-fill.svg": "8e06",
	"./calendar-event.svg": "b1f4",
	"./calendar-fill.svg": "f07e",
	"./calendar-minus-fill.svg": "3ca2",
	"./calendar-minus.svg": "3100",
	"./calendar-month-fill.svg": "4413",
	"./calendar-month.svg": "6ede",
	"./calendar-plus-fill.svg": "47ad",
	"./calendar-plus.svg": "c91e",
	"./calendar-range-fill.svg": "933c",
	"./calendar-range.svg": "9422",
	"./calendar-week-fill.svg": "dd0c",
	"./calendar-week.svg": "fb69",
	"./calendar-x-fill.svg": "b35e",
	"./calendar-x.svg": "e86b",
	"./calendar.svg": "3fb5",
	"./calendar2-check-fill.svg": "f474",
	"./calendar2-check.svg": "5ea5",
	"./calendar2-date-fill.svg": "eca8",
	"./calendar2-date.svg": "86e5",
	"./calendar2-day-fill.svg": "d638",
	"./calendar2-day.svg": "1302",
	"./calendar2-event-fill.svg": "1e60",
	"./calendar2-event.svg": "e747",
	"./calendar2-fill.svg": "9de7",
	"./calendar2-minus-fill.svg": "aaff",
	"./calendar2-minus.svg": "9a0d",
	"./calendar2-month-fill.svg": "21d0",
	"./calendar2-month.svg": "fed0",
	"./calendar2-plus-fill.svg": "fbe3",
	"./calendar2-plus.svg": "ee3c",
	"./calendar2-range-fill.svg": "b211",
	"./calendar2-range.svg": "a6f4",
	"./calendar2-week-fill.svg": "483e",
	"./calendar2-week.svg": "d1bf",
	"./calendar2-x-fill.svg": "41d1",
	"./calendar2-x.svg": "102c",
	"./calendar2.svg": "7826",
	"./calendar3-event-fill.svg": "e00c",
	"./calendar3-event.svg": "6e28",
	"./calendar3-fill.svg": "83b8",
	"./calendar3-range-fill.svg": "8d21",
	"./calendar3-range.svg": "fbb1",
	"./calendar3-week-fill.svg": "2a3d",
	"./calendar3-week.svg": "eaed",
	"./calendar3.svg": "d85c",
	"./calendar4-event.svg": "cef2",
	"./calendar4-range.svg": "7e74",
	"./calendar4-week.svg": "0d11",
	"./calendar4.svg": "99ae",
	"./camera-fill.svg": "33b5",
	"./camera-reels-fill.svg": "0b0c",
	"./camera-reels.svg": "f7e3",
	"./camera-video-fill.svg": "c728",
	"./camera-video-off-fill.svg": "3cda",
	"./camera-video-off.svg": "7866",
	"./camera-video.svg": "f7e1",
	"./camera.svg": "cb03",
	"./camera2.svg": "d9f4",
	"./capslock-fill.svg": "f48b",
	"./capslock.svg": "59c8",
	"./card-checklist.svg": "3e21",
	"./card-heading.svg": "bd38",
	"./card-image.svg": "6561",
	"./card-list.svg": "4add",
	"./card-text.svg": "3a7b",
	"./caret-down-fill.svg": "ba6c",
	"./caret-down-square-fill.svg": "0c24",
	"./caret-down-square.svg": "f3ac",
	"./caret-down.svg": "9ffa",
	"./caret-left-fill.svg": "724a1",
	"./caret-left-square-fill.svg": "7cdb9",
	"./caret-left-square.svg": "59d2",
	"./caret-left.svg": "ab93",
	"./caret-right-fill.svg": "4f59",
	"./caret-right-square-fill.svg": "f270",
	"./caret-right-square.svg": "e398",
	"./caret-right.svg": "7691",
	"./caret-up-fill.svg": "4133",
	"./caret-up-square-fill.svg": "2028",
	"./caret-up-square.svg": "a7528",
	"./caret-up.svg": "de72",
	"./cart-check-fill.svg": "a66b",
	"./cart-check.svg": "1074",
	"./cart-dash-fill.svg": "eea5",
	"./cart-dash.svg": "e41b",
	"./cart-fill.svg": "777f",
	"./cart-plus-fill.svg": "871b",
	"./cart-plus.svg": "7b96",
	"./cart-x-fill.svg": "2428",
	"./cart-x.svg": "eea54",
	"./cart.svg": "8ec4",
	"./cart2.svg": "6a48",
	"./cart3.svg": "d0e4",
	"./cart4.svg": "73bb",
	"./cash-stack.svg": "f1dc",
	"./cash.svg": "10d6",
	"./cast.svg": "b41c",
	"./chat-dots-fill.svg": "ef97",
	"./chat-dots.svg": "d6d4",
	"./chat-fill.svg": "c5de",
	"./chat-left-dots-fill.svg": "9c26",
	"./chat-left-dots.svg": "8a3b",
	"./chat-left-fill.svg": "9625",
	"./chat-left-quote-fill.svg": "433e",
	"./chat-left-quote.svg": "52b9",
	"./chat-left-text-fill.svg": "4859",
	"./chat-left-text.svg": "288b",
	"./chat-left.svg": "c9c9",
	"./chat-quote-fill.svg": "98b1",
	"./chat-quote.svg": "463f",
	"./chat-right-dots-fill.svg": "c6d7",
	"./chat-right-dots.svg": "b304",
	"./chat-right-fill.svg": "dd8e",
	"./chat-right-quote-fill.svg": "4c17",
	"./chat-right-quote.svg": "ab68",
	"./chat-right-text-fill.svg": "d56b",
	"./chat-right-text.svg": "a1fa2",
	"./chat-right.svg": "ef56",
	"./chat-square-dots-fill.svg": "115c",
	"./chat-square-dots.svg": "afb5",
	"./chat-square-fill.svg": "2da6",
	"./chat-square-quote-fill.svg": "955c",
	"./chat-square-quote.svg": "ef13",
	"./chat-square-text-fill.svg": "4dfb",
	"./chat-square-text.svg": "71c4",
	"./chat-square.svg": "48b5",
	"./chat-text-fill.svg": "8cff",
	"./chat-text.svg": "da8a",
	"./chat.svg": "5146",
	"./check-all.svg": "cd85",
	"./check-circle-fill.svg": "a894",
	"./check-circle.svg": "75aa",
	"./check-square-fill.svg": "735d",
	"./check-square.svg": "ddbe",
	"./check.svg": "0ca5",
	"./check2-all.svg": "120c",
	"./check2-circle.svg": "218d",
	"./check2-square.svg": "d1d9",
	"./check2.svg": "70df",
	"./chevron-bar-contract.svg": "3db0",
	"./chevron-bar-down.svg": "3fd9",
	"./chevron-bar-expand.svg": "063a",
	"./chevron-bar-left.svg": "4992",
	"./chevron-bar-right.svg": "dfd9",
	"./chevron-bar-up.svg": "12d5",
	"./chevron-compact-down.svg": "c410",
	"./chevron-compact-left.svg": "8533",
	"./chevron-compact-right.svg": "f588",
	"./chevron-compact-up.svg": "f1b6",
	"./chevron-contract.svg": "85c3",
	"./chevron-double-down.svg": "ec6f",
	"./chevron-double-left.svg": "6589",
	"./chevron-double-right.svg": "4984",
	"./chevron-double-up.svg": "9ffb",
	"./chevron-down.svg": "41ae",
	"./chevron-expand.svg": "5f46",
	"./chevron-left.svg": "b01d",
	"./chevron-right.svg": "6e06",
	"./chevron-up.svg": "856c",
	"./circle-fill.svg": "0ac6",
	"./circle-half.svg": "5772",
	"./circle-square.svg": "990f",
	"./circle.svg": "e692",
	"./clipboard-check.svg": "a4c9",
	"./clipboard-data.svg": "d728",
	"./clipboard-minus.svg": "911c",
	"./clipboard-plus.svg": "723c",
	"./clipboard-x.svg": "ba12",
	"./clipboard.svg": "f728",
	"./clock-fill.svg": "26b2",
	"./clock-history.svg": "1ea4",
	"./clock.svg": "2a1b",
	"./cloud-arrow-down-fill.svg": "0b80",
	"./cloud-arrow-down.svg": "22e0",
	"./cloud-arrow-up-fill.svg": "9285",
	"./cloud-arrow-up.svg": "f89d",
	"./cloud-check-fill.svg": "25e8",
	"./cloud-check.svg": "5b2a",
	"./cloud-download-fill.svg": "9c41",
	"./cloud-download.svg": "5e96",
	"./cloud-fill.svg": "7272",
	"./cloud-minus-fill.svg": "7378",
	"./cloud-minus.svg": "e6fd",
	"./cloud-plus-fill.svg": "e8ad",
	"./cloud-plus.svg": "f11b",
	"./cloud-slash-fill.svg": "3a7f",
	"./cloud-slash.svg": "ad61",
	"./cloud-upload-fill.svg": "ecfb",
	"./cloud-upload.svg": "b4ac",
	"./cloud.svg": "6fff",
	"./code-slash.svg": "3049",
	"./code-square.svg": "982f",
	"./code.svg": "1090",
	"./collection-fill.svg": "0e3d",
	"./collection-play-fill.svg": "0da5",
	"./collection-play.svg": "aae4",
	"./collection.svg": "a319",
	"./columns-gap.svg": "da93",
	"./columns.svg": "ffd2",
	"./command.svg": "1eb5",
	"./compass-fill.svg": "8359",
	"./compass.svg": "24855",
	"./cone-striped.svg": "a72a",
	"./cone.svg": "36a1",
	"./controller.svg": "268f",
	"./cpu-fill.svg": "be7f",
	"./cpu.svg": "b2c0",
	"./credit-card-2-back-fill.svg": "f856",
	"./credit-card-2-back.svg": "8395",
	"./credit-card-2-front-fill.svg": "651d",
	"./credit-card-2-front.svg": "2c77",
	"./credit-card-fill.svg": "2d01",
	"./credit-card.svg": "2907",
	"./crop.svg": "e8a8",
	"./cup-fill.svg": "ccbe",
	"./cup-straw.svg": "4383",
	"./cup.svg": "bb1e",
	"./cursor-fill.svg": "b076",
	"./cursor-text.svg": "9d11",
	"./cursor.svg": "0421",
	"./dash-circle-dotted.svg": "245c",
	"./dash-circle-fill.svg": "150a",
	"./dash-circle.svg": "d296",
	"./dash-square-dotted.svg": "94a8",
	"./dash-square-fill.svg": "ad45",
	"./dash-square.svg": "0e22",
	"./dash.svg": "2040",
	"./diagram-2-fill.svg": "3bfd",
	"./diagram-2.svg": "f346",
	"./diagram-3-fill.svg": "6219",
	"./diagram-3.svg": "2458",
	"./diamond-fill.svg": "969b",
	"./diamond-half.svg": "f1d2",
	"./diamond.svg": "b0f0",
	"./dice-1-fill.svg": "2d69",
	"./dice-1.svg": "dda6",
	"./dice-2-fill.svg": "d8df",
	"./dice-2.svg": "7ace",
	"./dice-3-fill.svg": "a044",
	"./dice-3.svg": "4ded",
	"./dice-4-fill.svg": "f9d2",
	"./dice-4.svg": "adff",
	"./dice-5-fill.svg": "d014",
	"./dice-5.svg": "0182",
	"./dice-6-fill.svg": "0871",
	"./dice-6.svg": "8492",
	"./disc-fill.svg": "eb42",
	"./disc.svg": "05d7",
	"./discord.svg": "58966",
	"./display-fill.svg": "2e55",
	"./display.svg": "b6ac",
	"./distribute-horizontal.svg": "d611",
	"./distribute-vertical.svg": "835c",
	"./door-closed-fill.svg": "6239",
	"./door-closed.svg": "47c1",
	"./door-open-fill.svg": "83e6",
	"./door-open.svg": "3b30",
	"./dot.svg": "f5b1",
	"./download.svg": "0afd",
	"./droplet-fill.svg": "c94e",
	"./droplet-half.svg": "610b",
	"./droplet.svg": "1188",
	"./earbuds.svg": "6085",
	"./easel-fill.svg": "ce4d",
	"./easel.svg": "2500",
	"./egg-fill.svg": "7cd5",
	"./egg-fried.svg": "1e39",
	"./egg.svg": "b1a3",
	"./eject-fill.svg": "d55a",
	"./eject.svg": "08eb",
	"./emoji-angry-fill.svg": "d6e0",
	"./emoji-angry.svg": "2df3",
	"./emoji-dizzy-fill.svg": "5aa4",
	"./emoji-dizzy.svg": "d0a4",
	"./emoji-expressionless-fill.svg": "c605",
	"./emoji-expressionless.svg": "a42f",
	"./emoji-frown-fill.svg": "d1c4",
	"./emoji-frown.svg": "e0bd",
	"./emoji-heart-eyes-fill.svg": "cad0",
	"./emoji-heart-eyes.svg": "fe69",
	"./emoji-laughing-fill.svg": "8748",
	"./emoji-laughing.svg": "c472",
	"./emoji-neutral-fill.svg": "d66b",
	"./emoji-neutral.svg": "7a2b",
	"./emoji-smile-fill.svg": "419b",
	"./emoji-smile-upside-down-fill.svg": "db78",
	"./emoji-smile-upside-down.svg": "527b",
	"./emoji-smile.svg": "996d",
	"./emoji-sunglasses-fill.svg": "dc6c",
	"./emoji-sunglasses.svg": "524e",
	"./emoji-wink-fill.svg": "95dd",
	"./emoji-wink.svg": "cf39",
	"./envelope-fill.svg": "5a93",
	"./envelope-open-fill.svg": "95d1",
	"./envelope-open.svg": "0fdfb",
	"./envelope.svg": "3e21f",
	"./eraser-fill.svg": "c540",
	"./eraser.svg": "52ee",
	"./exclamation-circle-fill.svg": "e8ca",
	"./exclamation-circle.svg": "5a90",
	"./exclamation-diamond-fill.svg": "94ff",
	"./exclamation-diamond.svg": "f6e1",
	"./exclamation-octagon-fill.svg": "ed64",
	"./exclamation-octagon.svg": "d17b",
	"./exclamation-square-fill.svg": "7364",
	"./exclamation-square.svg": "c598",
	"./exclamation-triangle-fill.svg": "5c12",
	"./exclamation-triangle.svg": "87a2",
	"./exclamation.svg": "3f41",
	"./exclude.svg": "eed9",
	"./eye-fill.svg": "9091",
	"./eye-slash-fill.svg": "0b1c",
	"./eye-slash.svg": "8e7c",
	"./eye.svg": "1f58",
	"./eyedropper.svg": "5720",
	"./eyeglasses.svg": "4c1b",
	"./facebook.svg": "d772",
	"./file-arrow-down-fill.svg": "39cf",
	"./file-arrow-down.svg": "4cc3",
	"./file-arrow-up-fill.svg": "5107",
	"./file-arrow-up.svg": "d1c9",
	"./file-bar-graph-fill.svg": "d495",
	"./file-bar-graph.svg": "7bac",
	"./file-binary-fill.svg": "7020",
	"./file-binary.svg": "4354",
	"./file-break-fill.svg": "43dd",
	"./file-break.svg": "cfde",
	"./file-check-fill.svg": "3dd7",
	"./file-check.svg": "a74e",
	"./file-code-fill.svg": "a316",
	"./file-code.svg": "248e",
	"./file-diff-fill.svg": "a550",
	"./file-diff.svg": "4734",
	"./file-earmark-arrow-down-fill.svg": "7d6c",
	"./file-earmark-arrow-down.svg": "7008",
	"./file-earmark-arrow-up-fill.svg": "6ea1",
	"./file-earmark-arrow-up.svg": "f3e3",
	"./file-earmark-bar-graph-fill.svg": "7c33",
	"./file-earmark-bar-graph.svg": "c5c2",
	"./file-earmark-binary-fill.svg": "8580",
	"./file-earmark-binary.svg": "1758",
	"./file-earmark-break-fill.svg": "2194",
	"./file-earmark-break.svg": "bedad",
	"./file-earmark-check-fill.svg": "2d94",
	"./file-earmark-check.svg": "5606",
	"./file-earmark-code-fill.svg": "a0eb",
	"./file-earmark-code.svg": "2a47",
	"./file-earmark-diff-fill.svg": "5360",
	"./file-earmark-diff.svg": "68a7",
	"./file-earmark-easel-fill.svg": "0ff7",
	"./file-earmark-easel.svg": "5471",
	"./file-earmark-excel-fill.svg": "1a89",
	"./file-earmark-excel.svg": "c0cd",
	"./file-earmark-fill.svg": "978f",
	"./file-earmark-font-fill.svg": "234a",
	"./file-earmark-font.svg": "6554",
	"./file-earmark-image-fill.svg": "9efd",
	"./file-earmark-image.svg": "6374",
	"./file-earmark-lock-fill.svg": "cc28",
	"./file-earmark-lock.svg": "912d",
	"./file-earmark-lock2-fill.svg": "a252",
	"./file-earmark-lock2.svg": "aee7",
	"./file-earmark-medical-fill.svg": "07e3",
	"./file-earmark-medical.svg": "13b5",
	"./file-earmark-minus-fill.svg": "1e72",
	"./file-earmark-minus.svg": "85d7",
	"./file-earmark-music-fill.svg": "d67a1",
	"./file-earmark-music.svg": "04b1",
	"./file-earmark-person-fill.svg": "16d2",
	"./file-earmark-person.svg": "f1d4",
	"./file-earmark-play-fill.svg": "b474",
	"./file-earmark-play.svg": "3ad5",
	"./file-earmark-plus-fill.svg": "2e38",
	"./file-earmark-plus.svg": "2d9c",
	"./file-earmark-post-fill.svg": "8a7f",
	"./file-earmark-post.svg": "4eb0",
	"./file-earmark-ppt-fill.svg": "8aa0",
	"./file-earmark-ppt.svg": "b0ef",
	"./file-earmark-richtext-fill.svg": "644e",
	"./file-earmark-richtext.svg": "5fed",
	"./file-earmark-ruled-fill.svg": "77cf",
	"./file-earmark-ruled.svg": "492e",
	"./file-earmark-slides-fill.svg": "0c81",
	"./file-earmark-slides.svg": "c1be",
	"./file-earmark-spreadsheet-fill.svg": "3e8f",
	"./file-earmark-spreadsheet.svg": "4f4c",
	"./file-earmark-text-fill.svg": "2956",
	"./file-earmark-text.svg": "45cf",
	"./file-earmark-word-fill.svg": "e9d3",
	"./file-earmark-word.svg": "eecf",
	"./file-earmark-x-fill.svg": "fa28",
	"./file-earmark-x.svg": "49d2",
	"./file-earmark-zip-fill.svg": "a614",
	"./file-earmark-zip.svg": "6d1e",
	"./file-earmark.svg": "c414",
	"./file-easel-fill.svg": "6cf2",
	"./file-easel.svg": "1275",
	"./file-excel-fill.svg": "2744",
	"./file-excel.svg": "0bd5",
	"./file-fill.svg": "7cd59",
	"./file-font-fill.svg": "9838",
	"./file-font.svg": "673e",
	"./file-image-fill.svg": "2616",
	"./file-image.svg": "c7ab",
	"./file-lock-fill.svg": "fc6b",
	"./file-lock.svg": "39cd",
	"./file-lock2-fill.svg": "91ef",
	"./file-lock2.svg": "52b4",
	"./file-medical-fill.svg": "e250",
	"./file-medical.svg": "d000",
	"./file-minus-fill.svg": "e3b6",
	"./file-minus.svg": "5324",
	"./file-music-fill.svg": "7b78",
	"./file-music.svg": "ad68",
	"./file-person-fill.svg": "247b",
	"./file-person.svg": "074a",
	"./file-play-fill.svg": "69bf",
	"./file-play.svg": "8698",
	"./file-plus-fill.svg": "69d9",
	"./file-plus.svg": "8cc9",
	"./file-post-fill.svg": "b930",
	"./file-post.svg": "5bad",
	"./file-ppt-fill.svg": "2dbe",
	"./file-ppt.svg": "0df9",
	"./file-richtext-fill.svg": "7f99",
	"./file-richtext.svg": "ae77",
	"./file-ruled-fill.svg": "c6aa",
	"./file-ruled.svg": "db1d",
	"./file-slides-fill.svg": "6d25",
	"./file-slides.svg": "8b84",
	"./file-spreadsheet-fill.svg": "9153",
	"./file-spreadsheet.svg": "6877",
	"./file-text-fill.svg": "b9c5",
	"./file-text.svg": "8a7b",
	"./file-word-fill.svg": "16be",
	"./file-word.svg": "a223",
	"./file-x-fill.svg": "d36f",
	"./file-x.svg": "8ef3",
	"./file-zip-fill.svg": "8845",
	"./file-zip.svg": "ff6f",
	"./file.svg": "d00a",
	"./files-alt.svg": "08b5",
	"./files.svg": "531d",
	"./film.svg": "40d2",
	"./filter-circle-fill.svg": "ebae",
	"./filter-circle.svg": "3209",
	"./filter-left.svg": "3148",
	"./filter-right.svg": "6a41",
	"./filter-square-fill.svg": "0510",
	"./filter-square.svg": "e249",
	"./filter.svg": "703c",
	"./flag-fill.svg": "87bd",
	"./flag.svg": "7543",
	"./flower1.svg": "4183",
	"./flower2.svg": "0b38",
	"./flower3.svg": "02f40",
	"./folder-check.svg": "d5c8",
	"./folder-fill.svg": "a49a",
	"./folder-minus.svg": "6487",
	"./folder-plus.svg": "d79a",
	"./folder-symlink-fill.svg": "4da1",
	"./folder-symlink.svg": "226f",
	"./folder-x.svg": "c696",
	"./folder.svg": "7415",
	"./folder2-open.svg": "14e3",
	"./folder2.svg": "01a4",
	"./fonts.svg": "9447",
	"./forward-fill.svg": "cf61",
	"./forward.svg": "816b",
	"./front.svg": "cf6e",
	"./fullscreen-exit.svg": "4ef4",
	"./fullscreen.svg": "4a4a",
	"./funnel-fill.svg": "dcbf",
	"./funnel.svg": "7024",
	"./gear-fill.svg": "4c3a",
	"./gear-wide-connected.svg": "8012",
	"./gear-wide.svg": "288b3",
	"./gear.svg": "a698",
	"./gem.svg": "f10f9",
	"./geo-alt-fill.svg": "5e76",
	"./geo-alt.svg": "4761",
	"./geo-fill.svg": "5cd0",
	"./geo.svg": "767d",
	"./gift-fill.svg": "0e4a",
	"./gift.svg": "23c67",
	"./github.svg": "7de1",
	"./globe.svg": "1344",
	"./globe2.svg": "c83f",
	"./google.svg": "b3ca",
	"./graph-down.svg": "4216",
	"./graph-up.svg": "a633",
	"./grid-1x2-fill.svg": "2ab7",
	"./grid-1x2.svg": "9062",
	"./grid-3x2-gap-fill.svg": "cf1a",
	"./grid-3x2-gap.svg": "e4d8",
	"./grid-3x2.svg": "d67e",
	"./grid-3x3-gap-fill.svg": "07af",
	"./grid-3x3-gap.svg": "db87",
	"./grid-3x3.svg": "1df4",
	"./grid-fill.svg": "5d4d",
	"./grid.svg": "f03f",
	"./grip-horizontal.svg": "beee",
	"./grip-vertical.svg": "050b",
	"./guertel.svg": "8009",
	"./hammer.svg": "85f8",
	"./hand-index-fill.svg": "ad2b",
	"./hand-index-thumb-fill.svg": "0a43",
	"./hand-index-thumb.svg": "f23b",
	"./hand-index.svg": "f5d6",
	"./hand-thumbs-down-fill.svg": "9753",
	"./hand-thumbs-down.svg": "1cc8",
	"./hand-thumbs-up-fill.svg": "203a",
	"./hand-thumbs-up.svg": "2879",
	"./handbag-fill.svg": "bc13",
	"./handbag.svg": "5967",
	"./hash.svg": "d4fa",
	"./hdd-fill.svg": "731f",
	"./hdd-network-fill.svg": "cca3",
	"./hdd-network.svg": "ef8b",
	"./hdd-rack-fill.svg": "578d",
	"./hdd-rack.svg": "f5f4",
	"./hdd-stack-fill.svg": "80d6",
	"./hdd-stack.svg": "e804",
	"./hdd.svg": "b67f",
	"./headphones.svg": "79d3",
	"./headset.svg": "a8db",
	"./heart-fill.svg": "ed73",
	"./heart-half.svg": "b62d",
	"./heart.svg": "e90b",
	"./heptagon-fill.svg": "2703",
	"./heptagon-half.svg": "0e37",
	"./heptagon.svg": "318b",
	"./hexagon-fill.svg": "9bf8",
	"./hexagon-half.svg": "1134",
	"./hexagon.svg": "79e8",
	"./hourglass-bottom.svg": "5599",
	"./hourglass-split.svg": "2529",
	"./hourglass-top.svg": "bb8e",
	"./hourglass.svg": "7eaa",
	"./house-door-fill.svg": "32cb",
	"./house-door.svg": "0492",
	"./house-fill.svg": "f6d0",
	"./house.svg": "8f37",
	"./hr.svg": "8223",
	"./image-alt.svg": "1140",
	"./image-fill.svg": "9f84",
	"./image.svg": "bd6f",
	"./images.svg": "25b0",
	"./inbox-fill.svg": "cf94",
	"./inbox.svg": "02c9",
	"./inboxes-fill.svg": "7a6d",
	"./inboxes.svg": "14f0",
	"./info-circle-fill.svg": "6e73",
	"./info-circle.svg": "b302",
	"./info-square-fill.svg": "2f2b",
	"./info-square.svg": "8a4d",
	"./info.svg": "1cfe",
	"./input-cursor-text.svg": "6825",
	"./input-cursor.svg": "d9250",
	"./instagram.svg": "0f05",
	"./intersect.svg": "c5dc",
	"./journal-album.svg": "232d",
	"./journal-arrow-down.svg": "0702",
	"./journal-arrow-up.svg": "9fd5",
	"./journal-bookmark-fill.svg": "f2ba",
	"./journal-bookmark.svg": "6de4",
	"./journal-check.svg": "a8de",
	"./journal-code.svg": "3775",
	"./journal-medical.svg": "e660",
	"./journal-minus.svg": "17ee",
	"./journal-plus.svg": "f35b",
	"./journal-richtext.svg": "45ad",
	"./journal-text.svg": "aad1",
	"./journal-x.svg": "7569",
	"./journal.svg": "2c5c",
	"./journals.svg": "185d",
	"./joystick.svg": "bf30",
	"./justify-left.svg": "6759",
	"./justify-right.svg": "6079",
	"./justify.svg": "bb31",
	"./kanban-fill.svg": "cf6f",
	"./kanban.svg": "9dbb",
	"./key-fill.svg": "7b0c",
	"./key.svg": "c663",
	"./keyboard-fill.svg": "89b3",
	"./keyboard.svg": "e0bf",
	"./ladder.svg": "8c3d",
	"./lamp-fill.svg": "ba5e",
	"./lamp.svg": "5e7e",
	"./laptop-fill.svg": "1168",
	"./laptop.svg": "1c21",
	"./layer-backward.svg": "586c",
	"./layer-forward.svg": "1a1e",
	"./layers-fill.svg": "2828",
	"./layers-half.svg": "e0f1",
	"./layers.svg": "1d22",
	"./layout-sidebar-inset-reverse.svg": "0118",
	"./layout-sidebar-inset.svg": "6f5f",
	"./layout-sidebar-reverse.svg": "8245",
	"./layout-sidebar.svg": "c254",
	"./layout-split.svg": "0a8d",
	"./layout-text-sidebar-reverse.svg": "6005",
	"./layout-text-sidebar.svg": "714a",
	"./layout-text-window-reverse.svg": "edf0",
	"./layout-text-window.svg": "8bac",
	"./layout-three-columns.svg": "4cec",
	"./layout-wtf.svg": "1d82",
	"./life-preserver.svg": "cb7d",
	"./lightbulb-fill.svg": "bc0a",
	"./lightbulb-off-fill.svg": "b043",
	"./lightbulb-off.svg": "7e1f",
	"./lightbulb.svg": "4739",
	"./lightning-fill.svg": "28a1",
	"./lightning.svg": "fa55",
	"./link-45deg.svg": "1214",
	"./link.svg": "7b53",
	"./linkedin.svg": "89db",
	"./list-check.svg": "15d8",
	"./list-nested.svg": "45da",
	"./list-ol.svg": "74925",
	"./list-stars.svg": "de42",
	"./list-task.svg": "f999",
	"./list-ul.svg": "c5b1",
	"./list.svg": "f629",
	"./lock-fill.svg": "796d",
	"./lock.svg": "e820",
	"./mailbox.svg": "a7b2",
	"./mailbox2.svg": "96ae",
	"./map-fill.svg": "d668",
	"./map.svg": "b4e6",
	"./markdown-fill.svg": "90bb",
	"./markdown.svg": "8409",
	"./mask.svg": "4487",
	"./megaphone-fill.svg": "beb7",
	"./megaphone.svg": "1f59",
	"./menu-app-fill.svg": "fee8",
	"./menu-app.svg": "4417",
	"./menu-button-fill.svg": "3f12",
	"./menu-button-wide-fill.svg": "a7a6",
	"./menu-button-wide.svg": "abd9",
	"./menu-button.svg": "2bdb",
	"./menu-down.svg": "4e40",
	"./menu-up.svg": "779f9",
	"./mic-fill.svg": "206a",
	"./mic-mute-fill.svg": "7be0",
	"./mic-mute.svg": "ecda",
	"./mic.svg": "9577",
	"./minecart-loaded.svg": "fbfa",
	"./minecart.svg": "1e18",
	"./moon.svg": "2110",
	"./mouse-fill.svg": "f872",
	"./mouse.svg": "30d8",
	"./mouse2-fill.svg": "b6cb",
	"./mouse2.svg": "68f1",
	"./mouse3-fill.svg": "66ae",
	"./mouse3.svg": "07e6",
	"./music-note-beamed.svg": "2712",
	"./music-note-list.svg": "4187",
	"./music-note.svg": "0307",
	"./music-player-fill.svg": "7420",
	"./music-player.svg": "100b",
	"./newspaper.svg": "dc14",
	"./node-minus-fill.svg": "4554",
	"./node-minus.svg": "885b",
	"./node-plus-fill.svg": "a385",
	"./node-plus.svg": "8d9c",
	"./nut-fill.svg": "ff3f",
	"./nut.svg": "9191",
	"./octagon-fill.svg": "ffb6",
	"./octagon-half.svg": "0abe",
	"./octagon.svg": "3fd6",
	"./option.svg": "f7eb",
	"./outlet.svg": "69bfb",
	"./paint-bucket.svg": "069d",
	"./palette-fill.svg": "a1f4",
	"./palette.svg": "5564",
	"./palette2.svg": "8046",
	"./paperclip.svg": "689a",
	"./paragraph.svg": "a079",
	"./patch-check-fill.svg": "d1f0",
	"./patch-check.svg": "3865",
	"./patch-exclamation-fill.svg": "4b6f",
	"./patch-exclamation.svg": "edb0",
	"./patch-minus-fill.svg": "cb43",
	"./patch-minus.svg": "7828",
	"./patch-plus-fill.svg": "80a4",
	"./patch-plus.svg": "9c7a",
	"./patch-question-fill.svg": "5b7a",
	"./patch-question.svg": "fe27",
	"./pause-btn-fill.svg": "c7bc",
	"./pause-btn.svg": "fe39",
	"./pause-circle-fill.svg": "b30b",
	"./pause-circle.svg": "abbf",
	"./pause-fill.svg": "2237",
	"./pause.svg": "bae8",
	"./peace-fill.svg": "0070",
	"./peace.svg": "7f32",
	"./pen-fill.svg": "6229",
	"./pen.svg": "bf50",
	"./pencil-fill.svg": "b3b6",
	"./pencil-square.svg": "3da9",
	"./pencil.svg": "54d6",
	"./pentagon-fill.svg": "4c2f",
	"./pentagon-half.svg": "63d6",
	"./pentagon.svg": "fed5",
	"./people-fill.svg": "4632",
	"./people.svg": "3dcd",
	"./percent.svg": "c14a",
	"./person-badge-fill.svg": "ca3e",
	"./person-badge.svg": "6df7",
	"./person-bounding-box.svg": "5b7ae",
	"./person-check-fill.svg": "d32d",
	"./person-check.svg": "b698",
	"./person-circle.svg": "f60d",
	"./person-dash-fill.svg": "7181",
	"./person-dash.svg": "66ef",
	"./person-fill.svg": "991a",
	"./person-lines-fill.svg": "e8fb",
	"./person-plus-fill.svg": "c446",
	"./person-plus.svg": "cfe1",
	"./person-square.svg": "50e6",
	"./person-x-fill.svg": "511f",
	"./person-x.svg": "1615",
	"./person.svg": "32ca",
	"./phone-fill.svg": "edd2",
	"./phone-landscape-fill.svg": "6740",
	"./phone-landscape.svg": "793b",
	"./phone-vibrate-fill.svg": "03b6",
	"./phone-vibrate.svg": "9388",
	"./phone.svg": "380e",
	"./pie-chart-fill.svg": "0216",
	"./pie-chart.svg": "2809",
	"./pin-angle-fill.svg": "ae9f",
	"./pin-angle.svg": "207b",
	"./pin-fill.svg": "5842",
	"./pin.svg": "9a16",
	"./pip-fill.svg": "b8e1",
	"./pip.svg": "99b0",
	"./play-btn-fill.svg": "f350",
	"./play-btn.svg": "d6cf",
	"./play-circle-fill.svg": "063d",
	"./play-circle.svg": "f29e",
	"./play-fill.svg": "67f6",
	"./play.svg": "3e94",
	"./plug-fill.svg": "4be6",
	"./plug.svg": "f2bf",
	"./plus-circle-dotted.svg": "b6a4",
	"./plus-circle-fill.svg": "c18e",
	"./plus-circle.svg": "4587",
	"./plus-square-dotted.svg": "a7e6",
	"./plus-square-fill.svg": "778b",
	"./plus-square.svg": "dfa7",
	"./plus.svg": "ebbe",
	"./power.svg": "e885",
	"./printer-fill.svg": "34db",
	"./printer.svg": "5292",
	"./puzzle-fill.svg": "67b0",
	"./puzzle.svg": "588a",
	"./question-circle-fill.svg": "b26d",
	"./question-circle.svg": "c148",
	"./question-diamond-fill.svg": "171d",
	"./question-diamond.svg": "242a",
	"./question-octagon-fill.svg": "bb8c",
	"./question-octagon.svg": "b83f",
	"./question-square-fill.svg": "52c5",
	"./question-square.svg": "dbf6",
	"./question.svg": "aa31",
	"./receipt-cutoff.svg": "da67",
	"./receipt.svg": "113a",
	"./reception-0.svg": "ac3c",
	"./reception-1.svg": "62c0",
	"./reception-2.svg": "30b3",
	"./reception-3.svg": "db3f",
	"./reception-4.svg": "8bf7",
	"./record-btn-fill.svg": "2d3c",
	"./record-btn.svg": "8694",
	"./record-circle-fill.svg": "ff97",
	"./record-circle.svg": "7fa1",
	"./record-fill.svg": "0680",
	"./record.svg": "9fba",
	"./record2-fill.svg": "123c",
	"./record2.svg": "30af",
	"./reply-all-fill.svg": "da62",
	"./reply-all.svg": "4c24",
	"./reply-fill.svg": "7dff",
	"./reply.svg": "d07f",
	"./robot.svg": "ae0a",
	"./rss-fill.svg": "db3a",
	"./rss.svg": "4df7",
	"./rulers.svg": "f3dd",
	"./save-fill.svg": "67b3",
	"./save.svg": "b4d5",
	"./save2-fill.svg": "f27a",
	"./save2.svg": "d7e0",
	"./scissors.svg": "6c13",
	"./screwdriver.svg": "7707",
	"./search.svg": "fdf4",
	"./segmented-nav.svg": "8feb",
	"./server.svg": "63b9",
	"./share-fill.svg": "c7d8",
	"./share.svg": "0bdd",
	"./shield-check.svg": "d19a",
	"./shield-exclamation.svg": "e085",
	"./shield-fill-check.svg": "52df",
	"./shield-fill-exclamation.svg": "fec4",
	"./shield-fill-minus.svg": "77ab",
	"./shield-fill-plus.svg": "817d",
	"./shield-fill-x.svg": "2c85",
	"./shield-fill.svg": "bcc0",
	"./shield-lock-fill.svg": "2a5c",
	"./shield-lock.svg": "ee77",
	"./shield-minus.svg": "836f",
	"./shield-plus.svg": "4b47",
	"./shield-shaded.svg": "8ca4",
	"./shield-slash-fill.svg": "7afa",
	"./shield-slash.svg": "b86e",
	"./shield-x.svg": "d179",
	"./shield.svg": "c4ec",
	"./shift-fill.svg": "1dff",
	"./shift.svg": "ed95",
	"./shop-window.svg": "8787",
	"./shop.svg": "3e9c",
	"./shuffle.svg": "b198",
	"./signpost-2-fill.svg": "438b",
	"./signpost-2.svg": "649a",
	"./signpost-fill.svg": "ae01",
	"./signpost-split-fill.svg": "51ec",
	"./signpost-split.svg": "365a",
	"./signpost.svg": "171c",
	"./sim-fill.svg": "0050",
	"./sim.svg": "f8c8",
	"./skip-backward-btn-fill.svg": "2ea9",
	"./skip-backward-btn.svg": "58e6",
	"./skip-backward-circle-fill.svg": "3499",
	"./skip-backward-circle.svg": "e707",
	"./skip-backward-fill.svg": "01ba",
	"./skip-backward.svg": "b6a1",
	"./skip-end-btn-fill.svg": "9fc5",
	"./skip-end-btn.svg": "00bd",
	"./skip-end-circle-fill.svg": "0272",
	"./skip-end-circle.svg": "a115",
	"./skip-end-fill.svg": "03d3",
	"./skip-end.svg": "0c815",
	"./skip-forward-btn-fill.svg": "e2c9",
	"./skip-forward-btn.svg": "df06",
	"./skip-forward-circle-fill.svg": "79b6",
	"./skip-forward-circle.svg": "a5dd",
	"./skip-forward-fill.svg": "6708",
	"./skip-forward.svg": "53bd",
	"./skip-start-btn-fill.svg": "78e3",
	"./skip-start-btn.svg": "ce01",
	"./skip-start-circle-fill.svg": "508f",
	"./skip-start-circle.svg": "970d",
	"./skip-start-fill.svg": "eeea",
	"./skip-start.svg": "93bc",
	"./slack.svg": "54bb",
	"./slash-circle-fill.svg": "f334",
	"./slash-circle.svg": "8650",
	"./slash-square-fill.svg": "c054",
	"./slash-square.svg": "4056",
	"./slash.svg": "abb2",
	"./sliders.svg": "8583",
	"./smartwatch.svg": "0757",
	"./sort-alpha-down-alt.svg": "2441",
	"./sort-alpha-down.svg": "9dac",
	"./sort-alpha-up-alt.svg": "ecf1",
	"./sort-alpha-up.svg": "d111",
	"./sort-down-alt.svg": "3101",
	"./sort-down.svg": "dd44",
	"./sort-numeric-down-alt.svg": "5027",
	"./sort-numeric-down.svg": "7cb6",
	"./sort-numeric-up-alt.svg": "849f",
	"./sort-numeric-up.svg": "5ba8",
	"./sort-up-alt.svg": "66e4",
	"./sort-up.svg": "a91e",
	"./soundwave.svg": "3092",
	"./speaker-fill.svg": "38b1",
	"./speaker.svg": "62e2",
	"./speedometer.svg": "0818b",
	"./speedometer2.svg": "982b",
	"./spellcheck.svg": "3f0c",
	"./square-fill.svg": "1a78",
	"./square-half.svg": "3479",
	"./square.svg": "9c93",
	"./stack.svg": "2b21",
	"./star-fill.svg": "0f62",
	"./star-half.svg": "6d0a",
	"./star.svg": "3296",
	"./stickies-fill.svg": "954b",
	"./stickies.svg": "4dfc",
	"./sticky-fill.svg": "2ab5",
	"./sticky.svg": "7eff",
	"./stop-btn-fill.svg": "f847",
	"./stop-btn.svg": "a97f",
	"./stop-circle-fill.svg": "d3ce",
	"./stop-circle.svg": "879e",
	"./stop-fill.svg": "712d",
	"./stop.svg": "7adf",
	"./stoplights-fill.svg": "3be4",
	"./stoplights.svg": "6a38",
	"./stopwatch-fill.svg": "109d",
	"./stopwatch.svg": "c5983",
	"./subtract.svg": "5b2d",
	"./suit-club-fill.svg": "5452",
	"./suit-club.svg": "e2a1",
	"./suit-diamond-fill.svg": "c526",
	"./suit-diamond.svg": "4495",
	"./suit-heart-fill.svg": "e331",
	"./suit-heart.svg": "6f0b",
	"./suit-spade-fill.svg": "3403",
	"./suit-spade.svg": "b4ba",
	"./sun.svg": "10e4",
	"./sunglasses.svg": "92cf",
	"./symmetry-horizontal.svg": "f7e5",
	"./symmetry-vertical.svg": "895d",
	"./table.svg": "e5d6",
	"./tablet-fill.svg": "ec40",
	"./tablet-landscape-fill.svg": "cf22",
	"./tablet-landscape.svg": "99dc",
	"./tablet.svg": "e862",
	"./tag-fill.svg": "632b",
	"./tag.svg": "5334",
	"./tags-fill.svg": "8576",
	"./tags.svg": "9e74",
	"./telegram.svg": "a871",
	"./telephone-fill.svg": "93a3",
	"./telephone-forward-fill.svg": "0251",
	"./telephone-forward.svg": "b15c",
	"./telephone-inbound-fill.svg": "132b",
	"./telephone-inbound.svg": "ea62",
	"./telephone-minus-fill.svg": "da89",
	"./telephone-minus.svg": "def5",
	"./telephone-outbound-fill.svg": "5e9c",
	"./telephone-outbound.svg": "18a6",
	"./telephone-plus-fill.svg": "e286",
	"./telephone-plus.svg": "c1ed",
	"./telephone-x-fill.svg": "3c8e",
	"./telephone-x.svg": "5d85",
	"./telephone.svg": "794e",
	"./terminal-fill.svg": "297a",
	"./terminal.svg": "7d24",
	"./text-center.svg": "6d4f",
	"./text-indent-left.svg": "a97e",
	"./text-indent-right.svg": "2b42",
	"./text-left.svg": "4dc8",
	"./text-paragraph.svg": "40b6",
	"./text-right.svg": "f4a6",
	"./textarea-resize.svg": "c726",
	"./textarea-t.svg": "784d",
	"./textarea.svg": "f375",
	"./thermometer-half.svg": "0d42",
	"./thermometer.svg": "df81",
	"./three-dots-vertical.svg": "6103",
	"./three-dots.svg": "056a",
	"./tkd_kick.svg": "970b",
	"./tkd_kicks_high.svg": "67b8",
	"./toggle-off.svg": "6251",
	"./toggle-on.svg": "5241",
	"./toggle2-off.svg": "247d",
	"./toggle2-on.svg": "4e70",
	"./toggles.svg": "50f2",
	"./toggles2.svg": "dd89",
	"./tools.svg": "0b6e",
	"./trash-fill.svg": "fa3f",
	"./trash.svg": "dd46",
	"./trash2-fill.svg": "2fe6",
	"./trash2.svg": "bb67",
	"./tree-fill.svg": "f666",
	"./tree.svg": "fe81",
	"./triangle-fill.svg": "0ff1",
	"./triangle-half.svg": "b9b1",
	"./triangle.svg": "ab46",
	"./trophy-fill.svg": "c91d",
	"./trophy.svg": "364a",
	"./truck-flatbed.svg": "c4dc",
	"./truck.svg": "3f00",
	"./tv-fill.svg": "8c4a",
	"./tv.svg": "6a27",
	"./twitch.svg": "4321",
	"./twitter.svg": "d233",
	"./type-bold.svg": "bc2e",
	"./type-h1.svg": "69e2",
	"./type-h2.svg": "9c9a",
	"./type-h3.svg": "59a5",
	"./type-italic.svg": "e00a",
	"./type-strikethrough.svg": "8692",
	"./type-underline.svg": "08c6",
	"./type.svg": "50ba",
	"./ui-checks-grid.svg": "8e50",
	"./ui-checks.svg": "4fe7",
	"./ui-radios-grid.svg": "2f99",
	"./ui-radios.svg": "123cc",
	"./union.svg": "a9ec",
	"./unlock-fill.svg": "2851",
	"./unlock.svg": "ddaa",
	"./upc-scan.svg": "1820",
	"./upc.svg": "a45e",
	"./upload.svg": "9e6f",
	"./vector-pen.svg": "2bba",
	"./view-list.svg": "87fa",
	"./view-stacked.svg": "22b2",
	"./vinyl-fill.svg": "20e4",
	"./vinyl.svg": "6f5c",
	"./voicemail.svg": "1a9a7",
	"./volume-down-fill.svg": "f92e",
	"./volume-down.svg": "540f",
	"./volume-mute-fill.svg": "61a2",
	"./volume-mute.svg": "284e",
	"./volume-off-fill.svg": "979a",
	"./volume-off.svg": "b886",
	"./volume-up-fill.svg": "c219",
	"./volume-up.svg": "4840",
	"./vr.svg": "5d51",
	"./wallet-fill.svg": "6dfa",
	"./wallet.svg": "8854",
	"./wallet2.svg": "0e6d",
	"./watch.svg": "aeb0",
	"./whatsapp.svg": "bf60",
	"./wifi-1.svg": "3d69",
	"./wifi-2.svg": "dba3",
	"./wifi-off.svg": "b725",
	"./wifi.svg": "64c5",
	"./window-dock.svg": "40fe",
	"./window-sidebar.svg": "4c72",
	"./window.svg": "90b7",
	"./wrench.svg": "1e08",
	"./x-circle-fill.svg": "19e1",
	"./x-circle.svg": "af7e",
	"./x-diamond-fill.svg": "58d3",
	"./x-diamond.svg": "25f5",
	"./x-octagon-fill.svg": "92d3",
	"./x-octagon.svg": "d321",
	"./x-square-fill.svg": "18cc",
	"./x-square.svg": "7b17",
	"./x.svg": "6850",
	"./youtube.svg": "12f5",
	"./zoom-in.svg": "7e17",
	"./zoom-out.svg": "1f72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a535";